import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { CookieDeclarationPanel } from "@/components/CookiePreferencesModal";
import PageHero from "@/components/PageHero";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 },
  }),
};

const DOC_KEYS = {
  "/politica-confidentialitate": "privacy",
  "/termeni-si-conditii": "terms",
  "/politica-cookie-uri": "cookies",
};

function renderLegalBody(body) {
  if (!body) return null;
  const trimmed = String(body).trim();
  if (!trimmed) return null;
  if (/<[a-z][\s\S]*>/i.test(trimmed)) {
    return <div className="legal-prose" dangerouslySetInnerHTML={{ __html: trimmed }} />;
  }
  return (
    <div className="legal-prose">
      {trimmed.split(/\n\n+/).map((para, i) => (
        <p key={i}>{para}</p>
      ))}
    </div>
  );
}

export default function LegalPage({ docKey }) {
  const { t } = useLanguage();
  const doc = t.legal?.[docKey];

  if (!doc) {
    return (
      <main className="min-h-[50vh] px-6 py-32 text-center text-[#3e2723]">
        <p>Document indisponibil.</p>
      </main>
    );
  }

  return (
    <main className="bg-white" data-testid={`legal-page-${docKey}`}>
      <PageHero
        variant="light"
        size="legal"
        eyebrow={t.footer.policies_title}
        title={doc.title}
        meta={doc.updated || undefined}
        containerClassName="max-w-7xl"
        testId={`legal-hero-${docKey}`}
      />

      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-3xl space-y-10 px-6 sm:px-12 lg:px-20">
          {doc.sections.map((section, i) => (
            <motion.article
              key={`${section.heading}-${i}`}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
            >
              <h2 className="font-display text-xl font-bold text-[#3e2723] sm:text-2xl">{section.heading}</h2>
              <div className="mt-3">{renderLegalBody(section.body)}</div>
            </motion.article>
          ))}
          {docKey === "cookies" ? <CookieDeclarationPanel /> : null}
        </div>
      </section>
    </main>
  );
}

export function legalDocKeyFromPath(pathname) {
  return DOC_KEYS[pathname] || null;
}

export { DOC_KEYS };
